import ChangeEmailForm from './ChangeEmailForm';

export default ChangeEmailForm;
